export const TITLE =
  " Piaggio Ape E-City FX  - Buy Electric Passenger Auto at Turno";

export const META_NAME = "description";

export const META_CONTENT =
  "Conquer city streets with the Montra ePV 2.0 electric auto. 160+ km range, spacious comfort, powerful performance. Free test drives, assured resale value - Turno, your EV partner.";

export const META_KEYWORDS_NAME = "keywords";

export const META_KEYWORDS_CONTENT =
  "electirc piaggio ape, piaggio electric auto, piaggio electric auto price, ape electric auto, ape electric auto price, ape electric auto on road price, ape city electric auto price, ape electric auto showroom near me, piaggio electric auto price in delhi, piaggio auto electric price, ape auto electric, piaggio auto electric, electric ape auto";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADER = "Highlights of Piaggio Ape E-City FX";

export const SUB_TEXT =
  "Piaggio Ape E-City FX offers unmatched profitability with a low running cost of 39p/km and impressive torque of 29 Nm for seamless navigation. Its swift acceleration, stylish Italian design, transparent windows, and an industry-leading 175,000 km warranty make it a compelling choice, ensuring both economic and aesthetic appeal.";

export const BENEFITS_HEADER = "Vehicle benefits of Piaggio Ape E-City FX";

export const VEHICLE_FEATURE_HEADER = "Features of Piaggio Ape E-City FX";

export const BRAND_DEALER_HEADER = "Ape Electric Auto Dealers Near Me: ";

export const BRAND_DEALER_DESCRIPITION =
  "You can find many Piaggio Ape FX dealers near you but if you want the best EV buying and owning experience, you must visit Turno, India’s No.1 EV Dealer. At Turno, we don’t only sell EVs, we also provide excellent after-sale support such as assured vehicle buyback, dedicated relationship manager, arranging roadside assistance and additional EV services.";

export const FAQ_HEADER_TEXT = "FAQs on Piaggio Ape E-City FX";

export const H1_HEADING = "Piaggio E-City FX";

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Piaggio/ape-e-city-fx";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Piaggio", href: "/electric-commercial-vehicles/Piaggio" },
  { label: "Piaggio E-City FX", href: VEHICLE_LINK },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Piaggio",
      item: "https://www.turno.club/electric-commercial-vehicles/Piaggio",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Piaggio E-City FX",
      item: VEHICLE_LINK,
    },
  ],
};